import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import { MenuList, MenuItem } from 'material-ui/Menu';

import Reboot from 'material-ui/Reboot';
import 'typeface-roboto';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

import TextField from 'material-ui/TextField';
import { ajaxPost, ajaxGet } from '../ajax';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import Portal from 'material-ui/Portal'
import Paper from 'material-ui/Paper';
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card';
import SettingsIcon from 'material-ui-icons/Settings';
import IconButton from 'material-ui/IconButton/IconButton';
import SelectMultipleDevice from './SelectMultipleDevice';
import Dialog, { DialogTitle, DialogContentText,DialogContent } from 'material-ui/Dialog';


var moment = require('moment');
const url = require('url');
const querystring = require('querystring');

const styles = theme => ({
  title:
    {
      color: "white",
      flex: 1,
      marginTop: 20,

    },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 15,
    width: 200,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  button:
    {
      height: 40,
      margin: 15,
    },
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    marginTop: 0,
  },
  main:
    {
      margin: "10px 10px 10px 10px",
      flexWrap: 'wrap'
    },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -15,
    marginLeft: -15,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
    display: 'inline-flex',
  },
  imgDiv:
    {
      width: 300,
      height: 300,
      border: "solid 1px gray",
      marginBottom: 30,
    },
  img:
    {
      width: 300,
      height: 300,
    },
  display:
    {
      display: 'inline-block'
    },
  paper:
    {
      display: 'inline-block',
      verticalAlign: 'top'
    },
  logo:
    {
      marginTop: 10,
      marginLeft:20,
      height: 50,
    },
  header:
    {
      position: 'relative',
      display: 'inline-flex',
      boxShadow: "0px 2px 10px darkgray",
      backgroundColor: "white",
      width: "100%",
      paddingBottom: 20,
    },
  card: {
    margin:"10px",
    width:"340px"
  },
  cardContainer:
  {
    display:"flex",
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  media: {
    height: 440,
    width:340
  },
  headLine:
    {
      marginTop: 30,
      marginLeft: 20,
      flex: 1,
    },
  instructWrapper:
    {
      position: 'relative',
      display: 'inline-flex',
      width: "100%",
    },
  instruct:
    {
      flex: 1,
      margin: "20px 0px 0px 20px",
    },

  cebgo:
    {
      marginTop: 16,
      height: 40,
      marginRight: 20,
    },
  timeWrapper:
    {
      fontWeight: "bold",
      margin: "20px 0px 0px 0px",
    },
  settings:
    {
      margin: "20px 20px 0px 0px",
    }
});



class Monitor extends Component {
  dt = moment().format('YYYY-MM-DD');
  state =
    {
      lastLogID: -1,
      date: "",
      time: "",
      list: [],
      display: [],
      lastOnline: moment().format(),
      displaySettings:false,
      devices : [],
    }

  componentDidMount = () => {
    const uri = url.parse(window.location.href);
    var qs = querystring.parse(uri.query);

    if( qs["dev"] != null)
    {
      this.state.devices = qs.dev.split(",").filter(x => x != "").map( x => parseInt(x));
    }

    var getID = () =>
    {
      ajaxPost({
        url: '/DeviceLogAPI/ListDeviceLogsAIMS',
        maxData: 50,
        data:
          {
            StartDate : this.dt,
            EndDate : this.dt,
            DeviceIDs: this.state.devices,
            EmployeeIDs:[],
          },
        onError: () => {
          setTimeout( getID, 1000);
        },
        onSuccess: (data, sender) => {
          this.state.lastLogID = -1;
          if( data.length > 0 )
            this.state.lastLogID = data[0].DeviceLogID;

          this.state.list = data;
          this.refresh();
        },
        finally: () => {},
        sender: this,
      }
      );
    }
    getID();
  
    setInterval(this.clock.bind(this), 1000);
  }

  clock = () => {
    this.setState({ date: moment().format("MMMM DD, YYYY") })
    this.setState({ time: moment().format("HH:mm:ss") })
  }

  getInfo = (data) =>
  {
    for( var i=0; i<3 && i< data.length; i++ )
    {
      var dl = data[i];
      ajaxGet(
        {
          url: '/DeviceLogAPI/GetAIMSMessage/' + dl.DeviceLogID.toString(),
          onError: () => {
          },
          onSuccess: (res,sender,attachment) => {
            if( res.AIMS != null )
            {
              attachment.DisplayTime = moment().subtract("10", "s").format();
              attachment.Message = res.AIMS;
              this.forceUpdate();
            }
          },
          finally: () => {
          },
          attachment:dl,
        }
      );        
    }
  }

  refresh = () => {
    
    const { display } = this.state;

    this.setState({display:display.filter(x=>moment(x.DisplayTime).add(15, "s").isAfter(moment()))})

    ajaxPost({
      url: '/DeviceLogAPI/ListDeviceLogsAIMS',
      maxData: 50,
      data:
        {
          LastLogID : this.state.lastLogID,
          DeviceIDs: this.state.devices,
          EmployeeIDs:[],
        },
      onError: () => {
      },
      onSuccess: (data, sender) => {
        sender.setState({ lastOnline: moment().format() });

        if( data.length == 0 )
          return;

        this.getInfo(data);
        this.state.lastLogID = data[0].DeviceLogID;
        var upd = data.concat(this.state.list).slice(0,50);
        var newDisp = data.concat(this.state.display).slice(0,3);
        sender.setState({ list: upd  });
        sender.setState({ display: newDisp });

      },
      finally: () => {
        setTimeout(this.refresh.bind(this), 2000);
      },
      sender: this,
    }
    )
  }

  handleSettings = () =>
  {
    this.setState({displaySettings:true});
  }

  onSelectDevice = (devices) =>
  {
    var x = 0;
    this.setState({displaySettings:false});
    var location = "monitor?dev=";
    devices.forEach( dev => location += dev.DeviceID.toString() + ",");
    window.location = location;
  }

  onCloseSelectDevice = () =>
  {
   this.setState({displaySettings:false});
  }

  render() {
    document.body.style.backgroundColor = "#F4F0F1";

    const { classes } = this.props;
    const { display, imageAvailable, displaySettings } = this.state;

    var file = '';
    if (display != null && imageAvailable)
      file = moment(display.FormattedTime).format("YYYYMMDDHHmmss") + "-" + display.AccessNumber + ".jpg";

    return (
      <div>
        <div style={{ "backgroundColor": "#FCFB01", "height": "5px" }}></div>
        <div className={classes.header}>
          <img src='logo.png' className={classes.logo} />
          <Typography variant="title" className={classes.headLine}>
            {"Crew Check-in / Check-out Monitoring System"}
          </Typography>
          <img src='cebgo.png' className={classes.cebgo} />
        </div>
        <div className={classes.instructWrapper} >
          <Typography type="headline" className={classes.instruct}>
            For technical assistance, you may contact CEBISDSERVICEDESK@CEBUPACIFICAIR.COM<br />
            or call 802-7111 loc 7111<br />
          </Typography>
          <Typography type="headline" className={classes.timeWrapper}>
            <div>{this.state.date}</div>
            <div style={{ "fontSize": "18px" }}>{this.state.time}</div>
          </Typography>
          <IconButton className={classes.settings} onClick={this.handleSettings.bind(this)}>
            <SettingsIcon />
          </IconButton>
        </div>
        <div className={classes.main}>
          <Paper className={classes.paper}>
            <Table className={classes.table}>
              <TableHead >
                <TableRow>
                  <TableCell>AIMS ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Terminal</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.list.map((n, index) => {
                  return (
                    <TableRow style={{ "backgroundColor": (index % 2) == 0 ? "#FAFAFA" : "" }}>
                      <TableCell>{n.EmployeeNo}</TableCell>
                      <TableCell>{n.FullName}</TableCell>
                      <TableCell>{n.LogType}</TableCell>
                      <TableCell>{n.RecordDate}</TableCell>
                      <TableCell>{n.RecordTime}</TableCell>
                      <TableCell>{n.Message}</TableCell>
                      <TableCell>{n.DeviceName}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Paper>
        </div>
        <div className={classes.cardContainer}>
        {display.map( item => 
          <Card className={classes.card}>
            <CardMedia id={item.elemID}
              className={classes.media}
              image={window.apihost + "/Files/Download?filename=" + moment(item.FormattedTime).format("YYYYMMDDHHmmss") + "-" + item.AccessNumber + ".jpg" + "&folder=ATTPhotos"}
            />
            <CardContent>
              <Typography variant="subheading">
                <div><b>{item.FullName}</b></div>
              </Typography>
              <Typography variant="body2">
                <div>{moment(item.FormattedTime).format("MM/DD/YYYY hh:mm")}</div>
              </Typography>
              <Typography variant="body2">
                <div>{item.Message}</div>
              </Typography>
            </CardContent>
          </Card>
         )
        }
        </div>
        {displaySettings && 
          <SelectMultipleDevice 
            title="Device Filter"
            caption="Select the devices this terminal will monitor.  Leave blank to monitor all devices"
            onAction={this.onSelectDevice}
            onClose={this.onCloseSelectDevice}
          />        
        }
        {
          this.state.lastOnline != null && !moment(this.state.lastOnline).add(10, "s").isAfter(moment()) &&
          <Dialog
            open={true}
            classes={classes}
            >
            <DialogTitle><span style={{"color":"red"}}>OFFLINE</span></DialogTitle>
            <DialogContent>
                <DialogContentText>
                This terminal is offline.
                For technical assistance, you may contact CEBISDSERVICEDESK@CEBUPACIFICAIR.COM<br />
                or call 802-7111 loc 7111<br />
                </DialogContentText>
            </DialogContent>
            </Dialog>                      
        }

      </div>
    );
  }
}

export default withStyles(styles)(Monitor);



// WEBPACK FOOTER //
// ./src/monitor/monitor.js